import { render, staticRenderFns } from "./cardUpload.vue?vue&type=template&id=f243d9a0&scoped=true"
import script from "./cardUpload.vue?vue&type=script&lang=js"
export * from "./cardUpload.vue?vue&type=script&lang=js"
import style0 from "./cardUpload.vue?vue&type=style&index=0&id=f243d9a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f243d9a0",
  null
  
)

export default component.exports